/** @jsx jsx */
import { Button, jsx } from "theme-ui"
import { useState } from "react"
import "./header.scss"
import { Link } from "gatsby"
import { navLinks } from "../utils/index"
import { CiMenuBurger } from "react-icons/ci"
import { useMemo } from "react"

const Header = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const menuLinks = useMemo(() => {
    return navLinks.map(({ name, link, outlined, custom, component }) =>
      custom ? (
        component()
      ) : (
        <Link
          key={link}
          className={`link ${outlined ? "link-highlight" : ""}`}
          to={link}
          aria-label={`Link do podstrony ${name}`}
        >
          {name}
        </Link>
      )
    )
  }, [navLinks])

  return (
    <header className="navbar">
      {/* <Link
        key="main-page"
        className="mainPageLink"
        role="link"
        to="/"
        aria-label="Link do strony  głownej"
      >
        {siteTitle}
      </Link> */}
      <Button
        className="menuButton"
        aria-label="Toggle Menu"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        Menu
        <CiMenuBurger />
      </Button>
      <div className={`headerLinks ${isMobileMenuOpen ? "" : "hidden"}`}>
        {menuLinks}
      </div>
      {children}
    </header>
  )
}

export default Header
